import { createUseStyles } from 'react-jss';
export var useStyles = createUseStyles({
  tab: {
    color: '#4B4B4B',
    width: '100%',
    padding: '4px 0',
    fontSize: 15,
    backgroundColor: 'transparent',
    border: 'none',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    opacity: 0.4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  activeTab: {
    opacity: 100
  },
  tabsHeaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  tabsHolder: {
    display: 'flex',
    flexDirection: 'row'
  },
  tabsSliderWrapper: {
    background: '#E2E2E2'
  },
  tabsSlider: {
    height: 2,
    backgroundColor: '#000',
    transition: '0.2s'
  },
  tabPanel: {
    marginTop: 20,
    width: '100%',
    height: '100%'
  },
  tabPanelActive: {
    display: 'flex'
  },
  tabPanelHidden: {
    display: 'none'
  }
});